import { fg } from '@atlassian/jira-feature-gating';
import {
	createRelayResource,
	RELAY_RESOURCE_TYPE,
} from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import QUERY, {
	type AtlassianNavigationNav4Query,
} from '@atlassian/jira-relay/src/__generated__/AtlassianNavigationNav4Query.graphql';
import type { ApplicationPermissions } from '@atlassian/jira-shared-types/src/tenant-context.tsx';

const hasOnlyJSMAndCSMAccess = (appPermissions: ApplicationPermissions) => {
	const {
		hasServiceDeskAccess,
		hasCustomerServiceAccess,
		hasSoftwareAccess,
		hasProductDiscoveryAccess,
	} = appPermissions;

	return (
		hasServiceDeskAccess &&
		hasCustomerServiceAccess &&
		!hasSoftwareAccess &&
		!hasProductDiscoveryAccess
	);
};

export const topNav4UIStateResource = createRelayResource<AtlassianNavigationNav4Query>({
	type: `${RELAY_RESOURCE_TYPE}_TOPNAV_UI_STATE_RELAY`,
	getQuery: (
		{ match, route },
		{ tenantContext: { cloudId, isAnonymous, atlassianAccountId, appPermissions } },
	) => {
		const issueKey = match.params.issueKey ?? '';
		const projectKey = match.params.projectKey ?? '';

		return {
			parameters: QUERY,
			variables: {
				cloudId,
				isAnonymous,
				atlassianAccountId: atlassianAccountId ?? '',
				isNavStateQuerySkipped:
					isAnonymous || fg('blu-8363-archive-legacy-resource-navigationuistate'),
				issueKey: issueKey ?? '',
				shouldCheckProjectTypeForIssue:
					route.group === 'issue' &&
					Boolean(issueKey) &&
					hasOnlyJSMAndCSMAccess(appPermissions) &&
					fg('team25-eu-jira-logo-updates-csm-jsm'),
				projectKey: projectKey ?? '',
				shouldCheckProjectType:
					Boolean(projectKey) &&
					hasOnlyJSMAndCSMAccess(appPermissions) &&
					fg('team25-eu-jira-logo-updates-csm-jsm'),
			},
			options: { fetchPolicy: 'store-and-network' },
		};
	},
	isCritical: true,
});
